import { useTaxSelector } from "../../../redux/general/reduxStore";

const useIAmAccountant = () => {
    const accountant = useTaxSelector((state) => state.user.accountant);

    return {
        isAccountant: accountant !== undefined,
        accountant,
    };
};

export default useIAmAccountant;
